
 export default function UpiMark({ style }) {
  return (
    <svg
      viewBox="0 0 52 24"
      fill="none"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true">
      <text
        x="0"
        y="18"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
        fontSize="16"
        fontWeight="800"
        fontStyle="italic"
        fill="currentColor">
        UPI
      </text>
      <path d="M36 4 L46 12 L36 20 Z" fill="#f59e0b" />
      <path d="M40 4 L50 12 L40 20 Z" fill="#16a34a" />
    </svg>
  );
}
